// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8ac673b4","239":"5ebc14ae","455":"3dce9e24"}[chunkId] + ".chunk.js";
};